/**
 * A little library for managing the lazy importing of JavaScript based on
 * scroll depth.
 */

export function lazyScript() {
  /** @type {IntersectionObserver} */
  let observer;

  /** @type {Set<Element>} */
  const targets = new Set();

  /** @type {WeakMap<Element, (target: Element) => void} */
  const callbacks = new WeakMap();

  return {
    /**
     * Initializes the IntersectionObserver
     * @param {IntersectionObserverInit} options Options to customize the observer
     */
    init(options) {
      observer = new IntersectionObserver((entries) => {
        for (let i = 0; i < entries.length; i++) {
          const entry = entries[i];

          if (entry.isIntersecting) {
            const target = entry.target;
            const callback = callbacks.get(target);
            callback(target);

            observer.unobserve(target);
          }
        }
      }, options);

      for (const target of targets) {
        observer.observe(target);
      }
    },

    /**
     * Adds a new element to observe and function to call on intersection.
     *
     * @param {Element} element The element to observe
     * @param {(target: Element) => void} callback The function to call on intersection
     */
    add(element, callback) {
      targets.add(element);
      callbacks.set(element, callback);
    },
  };
}
